var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoPersons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "004F4B36-ACF3-4216-A22D-6818E6F0D8EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Overview-&-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview-Temporary---GMS",
    transform: "translate(-802.000000, -101.000000)",
    fill: "#404040",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(632.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,23 C23.8807119,23 25,24.1192881 25,25.5 L25,25.5 L25,26.5 C25,26.7761424 24.7761424,27 24.5,27 C24.2238576,27 24,26.7761424 24,26.5 L24,26.5 L24,25.5 C24,24.6715729 23.3284271,24 22.5,24 L22.5,24 L18.5,24 C17.6715729,24 17,24.6715729 17,25.5 L17,25.5 L17,26.5 C17,26.7761424 16.7761424,27 16.5,27 C16.2238576,27 16,26.7761424 16,26.5 L16,26.5 L16,25.5 C16,24.1192881 17.1192881,23 18.5,23 L18.5,23 Z M26.0359642,23.066208 L26.1249999,23.080877 C27.2281241,23.3657022 27.99915,24.3603256 28,25.5 L28,25.5 L28,26.5 C28,26.7761424 27.7761424,27 27.5,27 C27.2238576,27 27,26.7761424 27,26.5 L27,26.5 L27.0000001,25.500373 C26.9994903,24.8167921 26.5368747,24.220018 25.8750001,24.049123 C25.6076264,23.9800874 25.4468415,23.7073739 25.515877,23.4400001 C25.5849126,23.1726264 25.8576261,23.0118415 26.1249999,23.080877 Z M20.5,17 C21.8807119,17 23,18.1192881 23,19.5 C23,20.8807119 21.8807119,22 20.5,22 C19.1192881,22 18,20.8807119 18,19.5 C18,18.1192881 19.1192881,17 20.5,17 Z M24.0349545,17.0661363 L24.1240196,17.080625 C25.2302164,17.3638561 26.0039216,18.3606195 26.0039216,19.5025 C26.0039216,20.6443805 25.2302164,21.6411439 24.1240196,21.924375 C23.8565067,21.9928691 23.5841191,21.8315325 23.515625,21.5640196 C23.4471309,21.2965067 23.6084675,21.0241191 23.8759804,20.955625 C24.5396985,20.7856863 25.0039216,20.1876283 25.0039216,19.5025 C25.0039216,18.8173717 24.5396985,18.2193137 23.8759804,18.049375 C23.6084675,17.9808809 23.4471309,17.7084933 23.515625,17.4409804 C23.5841191,17.1734675 23.8565067,17.0121309 24.1240196,17.080625 Z M20.5,18 C19.6715729,18 19,18.6715729 19,19.5 C19,20.3284271 19.6715729,21 20.5,21 C21.3284271,21 22,20.3284271 22,19.5 C22,18.6715729 21.3284271,18 20.5,18 Z",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoPersons);
export default __webpack_public_path__ + "static/media/two-persons.dadadb403126e5bcfc336694caf6d299.svg";
export { ForwardRef as ReactComponent };